export default "__VITE_ASSET__PuMXsDNG__"